<template>
  <div>
    <el-card shadow="never">
      <el-form ref="form" :model="formQuery" inline size="mini">
        <el-form-item label="日期：">
          <el-date-picker
              v-model="formQuery.date"
              type="date"
              placeholder="选择日期（默认当天）"
              value-format="yyyy-MM-dd"
              :clearable="true"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="关键字：">
          <el-input v-model="formQuery.keyword" placeholder="输入搜索关键字" clearable
                    @keyup.enter.native="handleSearch" style="width: 300px;"></el-input>
        </el-form-item>

        <el-form-item label="最大行数：">
          <el-input-number v-model="formQuery.maxLines" :min="10" :max="1000" :step="50"></el-input-number>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button type="success" @click="handleTail">查看最新日志</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never" style="margin-top: 10px;">
      <div slot="header">
        <span>查询结果</span>
        <span v-if="resultInfo" style="margin-left: 20px; color: #909399; font-size: 12px;">
          {{ resultInfo }}
        </span>
      </div>
      <div class="log-container">
        <pre class="log-content" v-if="logLines.length > 0">{{ logLines.join('\n') }}</pre>
        <el-empty v-else description="暂无日志数据"></el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formQuery: {
        keyword: '',
        maxLines: 200,
        date: '',
      },
      logLines: [],
      resultInfo: '',
    }
  },

  methods: {
    async handleSearch() {
      if (!this.formQuery.keyword) {
        this.$message.warning('请输入搜索关键字');
        return;
      }
      try {
        const res = await this.$axios.post('/tools/logs/search', {
          keyword: this.formQuery.keyword,
          maxLines: this.formQuery.maxLines,
          date: this.formQuery.date || undefined,
        });
        this.logLines = res.lines || [];
        this.resultInfo = `文件: ${res.file} | 匹配总数: ${res.total} | 显示: ${this.logLines.length} 行`;
      } catch (e) {
        // ignore
      }
    },

    async handleTail() {
      try {
        const res = await this.$axios.post('/tools/logs/tail', {
          lines: this.formQuery.maxLines,
          date: this.formQuery.date || undefined,
        });
        this.logLines = res.lines || [];
        this.resultInfo = `文件: ${res.file} | 最新 ${this.logLines.length} 行`;
      } catch (e) {
        // ignore
      }
    },
  }
}
</script>

<style scoped>
.log-container {
  max-height: 600px;
  overflow: auto;
  background-color: #1e1e1e;
  border-radius: 4px;
  padding: 12px;
}

.log-content {
  color: #d4d4d4;
  font-family: 'Courier New', Consolas, monospace;
  font-size: 12px;
  line-height: 1.6;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
